"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const redux_observable_1 = require("redux-observable");
const fieldsModal_1 = require("./fieldsModal");
const fields_1 = require("./fields");
const file_1 = require("./file");
const list_1 = require("./list");
const retrieved_1 = require("./retrieved");
const create_1 = require("./create");
const export_1 = require("./export");
const removal_1 = require("./removal");
const update_1 = require("./update");
exports.allEpics = (0, redux_observable_1.combineEpics)(
// fieldsModal
fieldsModal_1.retrieveReportOnFieldsModalOpen, file_1.autoDownloadFile, export_1.exportReport, 
// Current
fields_1.fetchReportFields, file_1.fetchReportFile, list_1.fetchReportList, retrieved_1.retrieveReport, create_1.createReport, removal_1.removeReports, update_1.updateReportTemplate);
//# sourceMappingURL=index.js.map